<div class="container" [attr.data-testid]="'custom-dialog-container'">
  @switch (type) {
    @case ('success') {
      <mat-icon [attr.data-testid]="'success-icon'">done</mat-icon>
    }
    @case ('failure') {
      <mat-icon class="failure" [attr.data-testid]="'failure-icon'"
        >close</mat-icon
      >
    }
    @case ('alert') {
      <mat-icon class="alert" [attr.data-testid]="'alert-icon'"
        >priority_high</mat-icon
      >
    }
    @case ('warning') {
      <mat-icon class="warning" [attr.data-testid]="'warning-icon'"
        >warning</mat-icon
      >
    }
  }

  <h3
    [class.small]="type === 'alert' || type === 'warning'"
    [attr.data-testid]="'dialog-title'"
  >
    {{ title }}
  </h3>

  <div
    class="content"
    [innerHTML]="content"
    [attr.data-testid]="'dialog-content'"
  ></div>

  <div
    class="buttons"
    [class.isVertical]="secondButton?.isVertical"
    [attr.data-testid]="'dialog-buttons'"
  >
    <button
      mat-raised-button
      color="primary"
      (click)="close()"
      [attr.data-testid]="'primary-button'"
    >
      <div class="button-text" [class.isIconLeft]="isIconLeft">
        <span [attr.data-testid]="'primary-button-text'"> {{ confirm }} </span>
        @if (icon) {
          <mat-icon [attr.data-testid]="'primary-button-icon'">{{
            icon
          }}</mat-icon>
        }
      </div>
    </button>

    @if (secondButton) {
      <button
        class="secondButton"
        mat-raised-button
        color="primary"
        (click)="secondButton.click()"
        [attr.data-testid]="'secondary-button'"
      >
        <div class="button-text" [class.isIconLeft]="secondButton.isIconLeft">
          <span [attr.data-testid]="'secondary-button-text'">
            {{ secondButton.text }}
          </span>
          @if (secondButton.icon) {
            <mat-icon [attr.data-testid]="'secondary-button-icon'">{{
              secondButton.icon
            }}</mat-icon>
          }
        </div>
      </button>
    }
  </div>
</div>
